import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { intersection } from 'lodash'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { CollapsableContent } from 'components/UI'
import { createErrorNotification } from 'store/actions/notifications'
import Api from 'services/Api'
import { t } from 'translations'

const BulletinNotificationStatusModal = ({ _id }) => {
  const dispatch = useDispatch()
  const [status, setStatus] = useState({ sms: { errors: [], delivered: [], sent: [] }, emails: { errors: [], accepted: [], delivered: [], opened: [] } })

  useEffect(() => {
    async function fetchBulletinStatus() {
      const { result, success } = await Api(`/contact/bulletin/contact/${_id}`)
      if (!success) dispatch(createErrorNotification())
      // Classify users by what events they have in their contactEvent
      const errorsSms = new Set()
      const pendingSms = new Set()
      const deliveredSms = new Set()

      // Classify users by what events they have in their contactEvent
      const errorsEmail = new Set()
      const pendingEmail = new Set()
      const deliveredEmail = new Set()
      const openedEmail = new Set()

      for (const { events, method, userId } of result) {
        const eventKeys = Object.keys(events)

        // Handle sms events and email events separately
        if (method === 'sms') {
          if (intersection(['failed', 'undelivered'], eventKeys).length) errorsSms.add(userId)
          else if (intersection(['received', 'delivered'], eventKeys).length) deliveredSms.add(userId)
          else if (intersection(['accepted', 'queued', 'sending', 'sent', 'receiving'], eventKeys).length) pendingSms.add(userId)
          else errorsSms.add(userId) // Handle cases where no events are logged (should not happen)
        } else if (method === 'email') {
          if (intersection(['permanent_fail', 'unsubscribe', 'complained'], eventKeys).length) errorsEmail.add(userId)
          else if (intersection(['delivered'], eventKeys).length) deliveredEmail.add(userId)
          else if (intersection(['temporary_fail', 'accepted'], eventKeys).length) pendingEmail.add(userId)
          else errorsEmail.add(userId) // Handle cases where no events are logged (should not happen)

          if (intersection(['opened', 'clicked'], eventKeys).length) openedEmail.add(userId)
        }
      }

      setStatus({
        sms: {
          errors: Array.from(errorsSms),
          delivered: Array.from(deliveredSms),
          sent: Array.from(pendingSms)
        },
        emails: {
          errors: Array.from(errorsEmail),
          delivered: Array.from(deliveredEmail),
          accepted: Array.from(pendingEmail),
          opened: Array.from(openedEmail)
        }
      })
    }
    fetchBulletinStatus()
  }, [_id, dispatch])

  return (
    <BaseModal hideButtons title={`manager.bulletins.NOTIFICATION_STATUS`}>
      <h5>{t('manager.bulletins.SMS')}</h5>
      <CollapsableContent type="smsErrors" usersIds={status.sms.errors} title="manager.bulletins.ERRORS" />
      <CollapsableContent type="smsPending" usersIds={status.sms.sent} title="manager.bulletins.PENDING" />
      <CollapsableContent type="smsDelivered" usersIds={status.sms.delivered} title="manager.bulletins.DELIVERED" />

      <h5>{t('manager.bulletins.EMAILS')}</h5>
      <CollapsableContent type="emailsErrors" usersIds={status.emails.errors} title="manager.bulletins.ERRORS" />
      <CollapsableContent type="emailsDelivered" usersIds={status.emails.delivered} title="manager.bulletins.DELIVERED" />
      <CollapsableContent type="emailsPending" usersIds={status.emails.accepted} title="manager.bulletins.PENDING" />
      <CollapsableContent type="emailsOpened" usersIds={status.emails.opened} title="manager.bulletins.OPENED" />

      <div className="mt-2">
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default BulletinNotificationStatusModal
